import { Text, Card, CardHeader, makeStyles, Divider, mergeClasses, tokens } from '@fluentui/react-components';
import { AgentRelatedLink } from '../../../../domain/agents/models/Agent';
import useOverviewStyles from '../styles/AgentOverviewStyles';
import { customColors } from '../../../../styles';

const useStyles = makeStyles({
    cardOverrides: {
        maxHeight: '325px',
        paddingBlock: '20px',
        paddingInline: '25px',
    },
    relatedLink: {
        color: customColors.linkColor,
        textDecoration: 'underline',
        fontSize: '1rem',
        fontWeight: tokens.fontWeightMedium,
    },
});

interface RelatedLinksProps {
    relatedLinks: AgentRelatedLink[] | undefined;
}

const RelatedLinks: React.FC<RelatedLinksProps> = ({ relatedLinks }) => {
    const styles = useStyles();
    const overviewStyles = useOverviewStyles();

    return (
        <Card className={mergeClasses(overviewStyles.card, styles.cardOverrides)}>
            <CardHeader
                className={overviewStyles.cardHeader}
                header={
                    <header className={overviewStyles.header}>
                        <Text className={overviewStyles.headerTitle}>Related Links</Text>
                        <Divider />
                    </header>
                }
            />
            {relatedLinks?.map((link, index) => (
                <a key={index} className={styles.relatedLink} href={link.link} target="_blank" rel="noreferrer">
                    {link.title}
                </a>
            ))}
        </Card>
    );
};

export default RelatedLinks;
